export const dscrTypes = [
  {
    type: "Most recent payment",
    calculationFields: []
  },
  {
    type: "Actual projected cashflows",
    calculationFields: [
      {
        fieldName: "Number of months",
        fieldLabel: "Actual projected cashflows",
        fieldInputType: "integer",
        additionalFields: null
      }
    ]
  },
  {
    type: "Actual trailing cashflows",
    calculationFields: [
      {
        fieldName: "Number of months",
        fieldLabel: "Actual trailing cashflows",
        fieldInputType: "integer",
        additionalFields: null
      }
    ]
  },
  {
    type: "Hypothetical amortization",
    calculationFields: [
      {
        fieldName: "Number of months",
        fieldLabel: "dscr amortization term",
        fieldInputType: "integer",
        additionalFields: null
      },
      {
        fieldName: "Percentage",
        fieldLabel: "dscr fixed rate",
        fieldInputType: "percentage",
        additionalFields: null
      },
      {
        fieldName: "Percentage",
        fieldLabel: "dscr treasury spread",
        fieldInputType: "percentage",
        additionalFields: null
      },
      {
        fieldName: "Percentage",
        fieldLabel: "dscr floating rate spread",
        fieldInputType: "percentage",
        additionalFields: null
      },
      {
        fieldName: "Select",
        fieldLabel: "index calculated on",
        fieldInputType: "select",
        additionalFields: [
          {type: "Report instance as of date"},
          {type: "Payment date (minus the lookback)"}
        ],
        additionalFieldsName: "indexCalculatedOn",
        additionalFieldsLabel: "Select",
        onlyDropdown: true
      },
      {
        fieldName: "Percentage",
        fieldLabel: "dscr swap rate",
        fieldInputType: "percentage",
        additionalFields: null
      },
      {
        fieldName: "Select",
        fieldLabel: "loan balance",
        fieldInputType: "select",
        additionalFields: [
          {type: "Current Balance"},
          {type: "Total Loan Amount"}
        ],
        additionalFieldsName: "loanBalance",
        additionalFieldsLabel: "Select",
        onlyDropdown: true
      },
      {
        fieldName: "Percentage",
        fieldLabel: "override hypothetical amortization rate?",
        fieldInputType: "percentage",
        additionalFields: null,
        includeToggle: true
      }
    ]
  },
  {
    type: "Max Interest + Actual Principal",
    calculationFields: [
      {
        fieldName: "Percentage",
        fieldLabel: "dscr floating rate spread",
        fieldInputType: "percentage",
        additionalFields: null
      },
      {
        fieldName: "Select",
        fieldLabel: "index calculated on",
        fieldInputType: "select",
        additionalFields: [
          {type: "Report instance as of date"},
          {type: "Payment date (minus the lookback)"}
        ],
        additionalFieldsName: "indexCalculatedOn",
        additionalFieldsLabel: "Select",
        onlyDropdown: true
      }
    ]
  },
  {
    type: "Rate Replacement",
    calculationFields: [
      {
        fieldName: "Percentage",
        fieldLabel: "rate",
        fieldInputType: "percentage",
        additionalFields: null
      },
      {
        fieldName: "Number of months",
        fieldLabel: "cashflows",
        fieldInputType: "integer",
        additionalFields: [{ type: "Trailing" }, { type: "Projected" }],
        additionalFieldsName: "CashflowType",
        additionalFieldsLabel: "Select Type"
      }
    ]
  },
  {
    type: "From file",
    calculationFields: []
  }
];

export const DSCR_TYPE_NAMES = {
  MOST_RECENT_PAYMENT: "Most recent payment",
  ACTUAL_PROJECTED_CASHFLOWS: "Actual projected cashflows",
  ACTUAL_TRAILING_CASHFLOWS: "Actual trailing cashflows",
  HYPOTHETICAL_AMORTIZATION: "Hypothetical amortization",
  MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL: "Max Interest + Actual Principal",
  RATE_REPLACEMENT: "Rate Replacement",
  FROM_FILE: "From file"
};

const validateHypotheticalAmortization = (inputValues) => {
    const amortizationTermInput = inputValues.find(dscrInputType => dscrInputType.fieldName === "dscr amortization term").inputValue;
  if (!amortizationTermInput) {
    return false;
  }

  const overrideRateInput = inputValues.find(dscrInputType => dscrInputType.fieldName === "override hypothetical amortization rate?");
  if (overrideRateInput && overrideRateInput.shouldOverrideRate && !overrideRateInput.inputValue) {
    return false;
  }

  const floatingSpreadInput = inputValues.find(dscrInputType => dscrInputType.fieldName === "dscr floating rate spread").inputValue;

  const indexCalculatedOn = inputValues.find(dscrInputType => dscrInputType.fieldName === "index calculated on");
  if (floatingSpreadInput && indexCalculatedOn && !indexCalculatedOn.additionalInputValue) {
    return false;
  }

  const withoutAmortizationTerm = inputValues.filter(
    (dscrInputType) => dscrInputType.fieldName !== "dscr amortization term" && dscrInputType.fieldName !== "index calculated on"
  );

    // validate that a field was seleced on "FROM_FILE" option
    const fromFIleSelection = inputValues.find(dscrInputType => dscrInputType.fieldName === "Select a field");
    if(fromFIleSelection && !fromFIleSelection.inputValue) {
      return false;
    }

  return withoutAmortizationTerm.some(dscrInputType => dscrInputType.inputValue);
};

export const validateDscrInputs = (inputValues, selectedType) => {
  if(selectedType === DSCR_TYPE_NAMES.HYPOTHETICAL_AMORTIZATION){
    return validateHypotheticalAmortization(inputValues);
  }
  else if(selectedType === DSCR_TYPE_NAMES.MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL){
    const floatingSpreadInput = inputValues.find(dscrInputType => dscrInputType.fieldName === "dscr floating rate spread").inputValue;
    const indexCalculatedOn = inputValues.find(dscrInputType => dscrInputType.fieldName === "index calculated on");
    return (floatingSpreadInput && indexCalculatedOn && indexCalculatedOn.additionalInputValue);
  }
  else{
    return inputValues.every(calc => {
      if (!calc.inputValue.length) {
        return false;
      }
      return !("additionalInputValue" in calc && !calc.additionalInputValue);
    });
  }
};


export const checkIfHorizontalDividerNeeded = (fieldLabel) => {
  return fieldLabel !== "dscr floating rate spread";
};